import { Attribute, Caption, Headline, Image, VideoList, SubHeader } from "../../subcomponents/subcomponents";
import Styles from "./view_course.module.css";
export const Course = ( props ) => {
    const { course, course: { image, imageTheme, episodes, payment, paymentTheme, courseDuration, courseName, courseNameTheme, courseLink, courseRate, courseRateTheme, teamSectionTitle, teamSectionIcon, teamSection, date, sections, captionTheme, captionColor, videos } = {} } = props;
    const { Course } = Styles;
    return (
        <div className={ Course }>
            {/*========Info Section========*/}
            { course && <InfoSection 
                image            = { image            } 
                imageTheme       = { imageTheme       }
                episodes         = { episodes         }
                payment          = { payment          }
                paymentTheme     = { paymentTheme     }
                courseDuration   = { courseDuration   } 
                courseName       = { courseName       } 
                courseNameTheme  = { courseNameTheme  }
                courseLink       = { courseLink       }
                courseRate       = { courseRate       }
                courseRateTheme  = { courseRateTheme  }
                teamSectionTitle = { teamSectionTitle }
                teamSectionIcon  = { teamSectionIcon  }
                teamSection      = { teamSection      }
                date             = { date             }
                sections         = { sections         }
                captionTheme     = { captionTheme     }
                captionColor     = { captionColor     }
            />}
            {/*========Video List==========*/}
            { videos && <VideoList 
                videos = { videos }
                title  =
                    {{ 
                        icon : <i className="bi bi-film"></i>,
                        text : "Course Episodes" 
                    }}
            />}
        </div>
    );
};
const InfoSection = ( props ) => {
    const { image, imageTheme, episodes, payment, paymentTheme, courseDuration, courseName, courseLink, courseNameTheme, courseRate, courseRateTheme, teamSectionTitle, teamSectionIcon, teamSection, date, sections, captionTheme, captionColor } = props;
    const { InfoSection } = Styles;
    const copyText = _ => {
        navigator.clipboard.writeText( courseLink )
        .then(() => {
            alert("list link copied to clipboard!");
        })
        .catch((error) => {
            alert("list link faild to be copied to clipboard!!");
        });
    }
    const Attributes = [
        { 
            icon : <i className="bi bi-collection-play-fill"></i>, 
            span : <span></span>, 
            text : episodes 
        },
        { 
            icon : <i className="bi bi-clock-fill"></i>, 
            span : <span></span>, 
            text : courseDuration 
        },
        { 
            text : payment, 
            color: paymentTheme 
        },
        { 
            icon : <i className="bi bi-share-fill"></i>, 
            span : <span style={{ display: "none" }}></span>,
            onClick: copyText,
        },
        { 
            icon : <i className="bi bi-play-circle-fill"></i>, 
            span : <span style={{ display: "none" }}></span> ,
            link: "/video_player"
        },
    ];
    
    return (
        <div className={ InfoSection }>
            {/*========Course Image========*/}
            { image && <Image 
                src   = { image      }
                theme = { imageTheme }
            />}
            {/*======Course Attributes=====*/}
            <Attribute 
                Attributes = { Attributes }
                width      = { 400        }
            />
            {/*========Course Title========*/}
            { courseName && <Headline 
                icon  = { <i className="bi bi-feather"></i> }
                text  = { courseName                        }
                width = { 400                               }
                theme = { courseNameTheme                   }
            />}
            {/*========Course Rate=========*/}
            { courseRate && <Headline
                icon  = { <i className="bi bi-bookmark-star-fill"></i> }
                text  = { courseRate                                   }
                width = { 400                                          }
                theme = { courseRateTheme                              }
            />}
            {/*====Course Creators Team====*/}
            { teamSection && <TeamSection 
                teamTitle     = { teamSectionTitle }
                teamTitleIcon = { teamSectionIcon  }
                team          = { teamSection      }
            /> }
            {/*=======Course Cption========*/}
            { sections && <Caption 
                date     = { date         }
                sections = { sections     }
                theme    = { captionTheme }
                color    = { captionColor } 
                width    = { 400          }
            />}
        </div>
    );
};
const TeamSection = ( props ) => {
    const { teamTitle, teamTitleIcon, team = [] } = props;
    const { TeamSection } = Styles;
    return (
        <div className={ TeamSection }>
            <SubHeader
                icon = { teamTitleIcon }
                text = { teamTitle     }
            />
            {
                team.map(( value, key ) => {
                    const { icon, text, theme } = value;
                    return (
                        <Headline
                            icon  = { icon  }
                            text  = { text  }
                            theme = { theme }
                            width = { 400   }
                            key   = { key   }
                        />
                    );
                })
            }
        </div>
    );
};
